<style scoped>
.search-input2{
    width: 350px;
    margin: 0 auto;
}
</style>

<template>
    <div class="p-l-10 p-r-5" @keydown.enter="handleInputSearch">
        <div class="search-input2 p-t-10">
            <AutoComplete
                v-model="searchKeyword"
                :data="autoCompleteResult"
                style="width:70%"
                placeholder="输入关键字：商家、机构、站点名称等，暂不支持多关键字"
                @on-focus="searchAutoComplete"
                @on-change="searchAutoComplete"
                @on-select="handleInputSearch"
            />
            <Button
                type="warning"
                style="width:15%;border-radius: 0 4px 4px 0;"
                @click="handleInputSearch"
            >
                <Icon size="24" type="ios-search"></Icon>
            </Button>
        </div>

        <Row class="p-t-5 p-b-5">
            <i-col span="6" class="p-t-5 search-label">搜索半径</i-col>
            <i-col span="12">
                <Slider
                    v-model="distance"
                    :step="50"
                    :max="1000"
                    @on-change="handleSearch"
                ></Slider>
            </i-col>
            <i-col span="6" class="p-t-5">
                <span class="text-black m-l-10">{{distance}} 米</span>
            </i-col>
        </Row>

        <p><span class="search-label">商圈画像</span></p>
        <Row class="p-t-5 p-b-5">
            <i-col span="24">
                <Tag size="medium">关键字： {{defaultSearchCondition.keywords}}</Tag>
                <Tag size="medium"
                    closable
                    v-for="dimension in showCheckDimension"
                    :key="'d' + dimension.id"
                    @on-close="handleCheckDimension(dimension.id)"
                >{{dimension.name}}</Tag>
            </i-col>
        </Row>

        <!-- 显示参数是否可调 -->
        <template v-if="indexParameter">
            <div class="p-t-5 p-b-5" v-for="(item,i) in listDimensions" :key="'l'+i">
                <p class="p-b-5"><span class="search-label">{{item.name}}</span></p>

                <Row :gutter="12" v-for="dis in item.list" :key="dis.id">

                    <i-col span="7">
                        <label style="cursor: pointer;" :class="checkDimension.includes(dis.id)?'active':''" @click="handleCheckDimension(dis.id)" >{{dis.name}}</label>
                    </i-col>
                    <i-col span="9">
                        <Slider
                        v-model="dis.rang"
                        range
                        :step="5"
                        :disabled="!checkDimension.includes(dis.id)"
                        style="margin-top: -8px;"
                        @on-change="handleChangeResultGroup"
                        ></Slider>
                    </i-col>
                    <i-col span="8">
                        <span v-if="checkDimension.includes(dis.id)">{{dis.rang[0]}}% - {{dis.rang[1]}}%</span>
                        <span
                        v-else
                        class="remark"
                        >/</span>
                    </i-col>

                </Row>
            </div>
        </template>
        <template v-else>
            <div class="p-t-5 p-b-5" v-for="(item,i) in listDimensions" :key="'l'+i">
                <p class="p-b-5"><span class="search-label">{{item.name}}</span></p>
                <Row>
                    <i-col span="8" v-for="dis in item.list" :key="dis.id">
                        <label
                            style="cursor: pointer;"
                            class="p-r-20"
                            :class="checkDimension.includes(dis.id)?'active':''"
                            @click="handleCheckDimension(dis.id)"
                        >{{dis.name}}</label>
                    </i-col>
                </Row>
            </div>
        </template>

        <!-- 显示综合定级 -->
        <template v-if="comprehensiveRating">
            <p class="p-t-5 p-b-5"><span class="search-label">综合定级</span></p>
            <Row class="p-t-5 p-b-5">
                <i-col span="24">
                    <a
                    class="p-r-20"
                    :class="chooseLevel === 2 ? 'active' : ''"
                    @click="handleChangeLevel(2)"
                    >2级</a>
                    <a
                    class="p-r-20"
                    :class="chooseLevel === 3 ? 'active' : ''"
                    @click="handleChangeLevel(3)"
                    >3级</a>
                    <a
                    class="p-r-20"
                    :class="chooseLevel === 4 ? 'active' : ''"
                    @click="handleChangeLevel(4)"
                    >4级</a>
                    <a
                    class="p-r-20"
                    :class="chooseLevel === 5 ? 'active' : ''"
                    @click="handleChangeLevel(5)"
                    >5级</a>

                    <div
                    v-for="(color,i) in levelColorList"
                    :key="i"
                    class="search-level"
                    :style="{'background-color': color}"
                    ></div>
                </i-col>
            </Row>
        </template>

        <!-- 显示线路 -->
        <template v-if="currentCityCode">
            <p class="p-t-5 p-b-5"><span class="search-label">选择线路</span></p>
            <Row class="p-t-5 p-b-5">
                <i-col span="24">
                    <a @click="handleAsset(-1)" :class="checkAssets.length<1?'active':''">全部</a>
                    <a
                    v-for="asset in listAssets"
                    :key="asset.id"
                    class="m-l-10"
                    :class="checkAssets.includes(asset.id)?'active':''"
                    @click="handleAsset(asset.id)"
                    >{{asset.name.substr(asset.name.indexOf('铁') + 1)}}</a>
                </i-col>
            </Row>
        </template>
    </div>
</template>

<script>
import { getStorage, setStorage } from '@/utils/storage'
import { getMatchKeywords } from '@/api/search'

export default {
  data () {
    return {
      distance: 500,

      chooseLevel: 2,
      levelColor: ['#808695', '#19be6b', '#2d8cf0', '#ff9900', '#ed4014'],
      searchKeyword: '', // 查询关键字
      autoCompleteResult: [], // 自动查询结果

      listDimensions: [], // 全部指标
      checkDimension: [],
      allDimensionIds: [], // 合并后的所有分类
      showCheckDimension: [],

      listCitys: [], // 全部可用城市
      cityGroup: ['ABCD', 'FGHJ', 'KLNQ', 'STW', 'XYZ'], // 城市分组
      checkCitys: [],

      listAssets: [], // 全部可用线路
      checkAssets: []
    }
  },
  created () {
    this.initPageData()
  },
  methods: {
    initPageData () {
      this.searchKeyword = this.defaultSearchCondition.keywords
      this.distance = this.defaultSearchCondition.distance
      this.checkCitys = this.currentCityCode ? [this.currentCityCode] : this.defaultSearchCondition.cityCodes
      this.checkDimension = this.defaultSearchCondition.indexes.map(x => x.index)
      this.checkAssets = this.defaultSearchCondition.assetIds
      this.chooseLevel = this.defaultSearchCondition.dynamicLevel

      if (this.currentCityCode) { // 获取当前城市的可用线路
        this.$store.dispatch('getAllAssets', this.currentCityCode).then(assets => {
          this.listAssets = []
          assets.forEach(element => {
            if (this.companySetting.assetIds.includes(element.id)) {
              this.listAssets.push(element)
            }
          })
        })
      } else { // 获取所有可用的城市清单
        this.$store.dispatch('getCityList').then(citys => {
          this.listCitys = citys
        })
      }

      // 获取所有查询指标
      this.$store.dispatch('getDimensionList').then(dimenstion => {
        this.listDimensions = dimenstion.map(x => {
          return {
            name: x.name,
            list: x.list.map(item => {
              return {
                id: item.id,
                name: item.name,
                rang: [0, 100]
              }
            })
          }
        })

        // 格式化查询的
        this.listDimensions.forEach(element => {
          this.allDimensionIds = this.allDimensionIds.concat(element.list)
        })
        this.formatShowCheckDimension()
      }).then(() => {
        this.handleSearch()
      })
    },
    handleInputSearch (val) { // 重新输入关键字， 那么需要重置所有条件
      if (val && !val.type) { // 自动完成选择值
        this.searchKeyword = val
      }

      this.checkCitys = []
      this.checkAssets = []
      this.distance = 500
      this.chooseLevel = 2
      this.checkDimension = this.getAllDimensions()
      this.formatShowCheckDimension()

      // 往cookie中插入该关键字
      if (this.searchKeyword.trim() !== '') {
        let cookieKeyWords = getStorage('oohforce_keywords') || []
        if (!cookieKeyWords.includes(this.searchKeyword)) {
          cookieKeyWords.push(this.searchKeyword)
        } else {
          cookieKeyWords.splice(cookieKeyWords.findIndex(x => x === this.searchKeyword), 1)
          cookieKeyWords.push(this.searchKeyword)
        }
        // 移除历史的空白或者NULL值
        this.clearKeyWorkEmpty(cookieKeyWords)
        setStorage('oohforce_keywords', cookieKeyWords)
      }

      this.handleSearch()
    },
    clearKeyWorkEmpty (cookieKeyWords) {
      if (cookieKeyWords.includes(null) || cookieKeyWords.includes('')) {
        cookieKeyWords.splice(cookieKeyWords.findIndex(x => x === null || x === ''), 1)
        this.clearKeyWorkEmpty(cookieKeyWords)
      }
    },
    searchAutoComplete () {
      if (this.searchKeyword.trim() === '') { // 从cookie中获取数据, 倒序取值
        let currentKeywords = getStorage('oohforce_keywords') || []
        let history = []

        for (let index = 0; index < 10; index++) {
          if (currentKeywords.length - index - 1 > -1 && currentKeywords[currentKeywords.length - index - 1] !== null) {
            history.push(currentKeywords[currentKeywords.length - index - 1])
          }
        }
        this.autoCompleteResult = history
      } else {
        let postData = {
          distance: this.distance,
          size: 10,
          keyword: this.searchKeyword
        }

        getMatchKeywords(postData).then(res => {
          this.autoCompleteResult = res
        })
      }
    },
    getAllDimensions () {
      let dismenstions = []
      this.listDimensions.forEach(element => {
        element.list.forEach(item => {
          dismenstions.push(item.id)
        })
      })

      return dismenstions
    },
    formatShowCheckDimension () {
      if (!this.checkDimension) { return }

      this.showCheckDimension = []
      this.checkDimension.forEach(element => {
        this.showCheckDimension.push(
          this.allDimensionIds.find(x => x.id === element)
        )
      })
    },
    handleCheckDimension (id) {
      if (this.checkDimension.includes(id)) {
        const index = this.checkDimension.indexOf(id)
        this.checkDimension.splice(index, 1)
      } else {
        this.checkDimension.push(id)
      }
      this.formatShowCheckDimension()
      this.handleSearch()
    },
    handleChangeLevel (level) {
      this.chooseLevel = level
      this.handleSearch()
    },
    handleCheckCity (cityCode) {
      if (this.checkCitys.includes(cityCode)) {
        const index = this.checkCitys.indexOf(cityCode)
        this.checkCitys.splice(index, 1)
      } else {
        this.checkCitys.push(cityCode)
      }

      this.handleSearch()
    },
    handleAsset (assetId) {
      if (assetId === -1) {
        this.checkAssets = []
      } else if (this.checkAssets.includes(assetId)) {
        const index = this.checkAssets.indexOf(assetId)
        this.checkAssets.splice(index, 1)
      } else {
        this.checkAssets.push(assetId)
      }

      this.handleSearch()
    },
    handleSearch () {
      let searchDTO = this.getSearchConditionDTO()
      this.$store.commit('set_search_searchCondition', searchDTO)
      this.$store.commit('set_search_beginSearch', new Date())
    },
    getSearchConditionDTO () { // 当前查询实体
      let checkDimensionIndexes = []
      let currentCheckDismenstaionValue
      let dismenstions = []
      // 获取选中的参数指标
      this.listDimensions.forEach(element => {
        element.list.forEach(item => {
          dismenstions.push(item)
        })
      })
      this.checkDimension.forEach(element => {
        currentCheckDismenstaionValue = dismenstions.find(x => x.id === element)

        checkDimensionIndexes.push({
          index: element,
          start: currentCheckDismenstaionValue.rang[0],
          end: currentCheckDismenstaionValue.rang[1]
        })
      })
      // 获取选中的线路
      let currentCheckAssets = []
      if (this.currentCityCode) {
        if (this.checkAssets.length > 0) {
          currentCheckAssets = this.checkAssets
        } else {
          currentCheckAssets = this.companySetting.assetIds
        }
      }
      // 获取综合定级

      return {
        cityCodes: this.currentCityCode ? [this.currentCityCode] : this.checkCitys,
        assetIds: currentCheckAssets,
        distance: this.distance,
        dynamicLevel: this.comprehensiveRating ? this.chooseLevel : 0,
        indexes: checkDimensionIndexes,
        keywords: this.searchKeyword
      }
    },
    handleChangeResultGroup () {
      this.$store.commit('set_search_searchCondition', this.getSearchConditionDTO())
      // 开始根据参数从查询结果中过滤出结果
      this.$store.commit('set_search_filterData', new Date().getTime())
    }
  },
  computed: {
    levelColorList () {
      let start = 5 - this.chooseLevel
      let allowColor = []

      for (let index = start; index < 5; index++) {
        allowColor.push(this.levelColor[index])
      }

      return allowColor
    },
    defaultSearchCondition () {
      return this.$store.state.search.searchCondition
    },
    companySetting () {
      return this.$store.state.user.companySetting
    },
    currentCityCode () {
      return this.companySetting ? this.companySetting.citys[0] : null
    },
    indexParameter () { // 指标参数可调
      return this.companySetting ? this.companySetting.indexParameter : null
    },
    comprehensiveRating () { // 综合定级
      return this.companySetting ? this.companySetting.comprehensiveRating : null
    }
  }
}
</script>
